import React from 'react';
import MDX from '@mdx-js/runtime';
import { useSelector, shallowEqual } from 'react-redux';
import Pdf from '../Pdf/Pdf';
import Download from '../Download/Download';
import Asset from '../Asset';
import Media from '../../Media/Media';
import CmsTools from '../../../CmsTools/CmsTools';
import { pseudolocalize } from '../../common/pseudolocalize/pseudolocalize';
import Highlight from 'react-highlight.js';
import ErrorBoundry from '../../common/ErrorBoundry/ErrorBoundry';

const codeHighlight = (className, children) => {
  return (
    <Highlight language={className ? className : 'plaintext'}>
      {children}
    </Highlight>
  );
};
const components = {
  // keeps markdown from puttin any wrapper on the content
  wrapper: props => <>{props.children}</>,
  Pdf: ({ id }) => <Pdf id={id} />,
  Download: ({ id }) => <Download id={id} />,
  Asset: ({ id }) => <Asset id={id} />,
  Media: ({ use }) => <Media use={use} />,
  code: ({ className, children }) => codeHighlight(className, children),
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
};

const highlightWords = (content, words) => {
  let updatedContent = content;
  words.forEach(word => {
    let regex = new RegExp(`(${word})`, 'gi');
    updatedContent = updatedContent.replace(regex, `<mark>$1</mark>`);
  });
  return updatedContent;
};

const HandleContent = ({ id, content, md, className, style, pre }) => {
  const isPseudo = useSelector(
    state => state.LanguageState.isPseudo,
    shallowEqual
  );
  content = isPseudo ? pseudolocalize(content) : content;

  return (
    // we're putting the content wrapper here
    <div
      id={id}
      className={`text-asset ${className}`}
      style={{ ...style, position: 'relative' }}
    >
      <CmsTools id={id} type="assets" subtype="text" />
      {/* {md && content} */}
      {md && (
        <ErrorBoundry>
          <MDX components={components}>
            {
              content
              // .replace('https://', 'ht&#8203;tps://')
              // .replace('http://', 'ht&#8203;tp://')
              // .replace('file://', 'fi&#8203;le://')
              // .replace('ftp://', 'ft&#8203;p://')
            }
          </MDX>
        </ErrorBoundry>
      )}
      {pre && <pre>{content}</pre>}
      {!md && !pre && content}
    </div>
  );
};

const Text = props => {
  const { id, content, md, className, style, pre } = props;
  const { assetManifest, searchedWords } = useSelector(
    state => ({
      assetManifest: state.BlockState.assetManifest,
      searchedWords: state.SearchState.searchedWords
    }),
    shallowEqual
  );

  if (!assetManifest) return false;
  // if we have content, display it right up
  if (content)
    return (
      <HandleContent
        id={id}
        md={md}
        pre={pre}
        content={highlightWords(content, searchedWords)}
        className={className}
        style={style}
      />
    );
  if (id && !content) {
    // if we don't have content, get it
    let asset = assetManifest.assets.find(a => a.id === id);
    return (
      <HandleContent
        id={id}
        md={md}
        pre={pre}
        content={highlightWords(asset.content, searchedWords)}
        className={className}
        style={style}
      />
    );
  }
  // something we didn't account for is happening here.
  return 'something went wrong loading text asset';
};

export default Text;
